import {useState, useEffect} from 'react';

import Spinner from './_spinner';
import Icon from './_icon';

const OverlayLoader = ({message, scrollingMessages, showSpinner, visible, children, onClose}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => setCount(prev => prev + 1), 7000); // 7 second wait

    return () => clearTimeout(timeout);
  }, [count]);

  if(!visible) {
    return null;
  }

  const i = count % scrollingMessages.length;
  const srollMessage = (scrollingMessages && scrollingMessages.length) ? scrollingMessages[i] : null;
  const displayedMessage = message || srollMessage;

  return (
    <div className="overlay-loader">
      <div className="overlay-loader_box">
        <div className="overlay-loader_box-content">
          <div className="overlay-loader_box-content_close-container">
            <div className="overlay-loader_box-content_close" onClick={onClose}>
              <Icon icon="close" />
            </div>
          </div>
          {showSpinner && <div className="overlay-loader_box-content_spinner"><Spinner /></div>}
          {displayedMessage && (
            <div className="overlay-loader_box-content_message" dangerouslySetInnerHTML={{__html: displayedMessage}} />
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

OverlayLoader.propTypes = {
  message: PropTypes.string,
  scrollingMessages: PropTypes.arrayOf(PropTypes.string),
  showSpinner: PropTypes.bool,
  visible: PropTypes.bool,
  children: PropTypes.node,
  onClose: PropTypes.func
};

OverlayLoader.defaultProps = {
  message: 'Loading...',
  scrollingMessages: [],
  showSpinner: true,
  visible: false,
  children: null,
  onClose() {}
};

export default OverlayLoader;
